import { isAppleDevice } from '../../../../../util/utils';

export const startStream = async (): Promise<MediaStream> => {
  if (isAppleDevice()) {
    return getUserMedia('');
  }
  const s = await getUserMedia('');
  stopStream(s);
  const videoDevices = await getVideoDevices();
  const preferredDevice = await getPreferredDeviceId(videoDevices);
  return await getUserMedia(preferredDevice);
};

export const stopStream = (stream?: MediaStream): void => {
  stream?.getTracks().forEach((track) => {
    track.stop();
  });
};

const getUserMedia = (preferredDevice: string): Promise<MediaStream> =>
  navigator.mediaDevices.getUserMedia({
    audio: false,
    video: {
      facingMode: {
        ideal: 'environment',
      },
      deviceId: { ideal: preferredDevice },
      width: { ideal: 1920 },
      height: { ideal: 1440 },
      aspectRatio: 4 / 3,
    },
  });

const getPreferredDeviceId = async (
  videoDevices: MediaDeviceInfo[],
): Promise<string> => {
  let preferredDevice = '';
  for (const mdi of videoDevices) {
    const s = await navigator.mediaDevices.getUserMedia({
      video: {
        deviceId: { exact: mdi.deviceId },
      },
    });
    s.getTracks().every((track) => {
      if (!('getCapabilities' in track)) {
        return false;
      }
      const c = track.getCapabilities();
      if ((c as any).torch) {
        preferredDevice = track.getSettings().deviceId || '';
        return false;
      }
      return true;
    });
    stopStream(s);
  }
  return preferredDevice;
};

const getVideoDevices = async (): Promise<MediaDeviceInfo[]> =>
  navigator.mediaDevices
    .enumerateDevices()
    .then((mdi) => mdi.filter((d) => d.kind === 'videoinput'));
